<template>
  <section class="content waste_collection_wrp">
    <div class="main_select_wrp_relative main_select_wrp_vechile">
      <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="width: 50%">
          <div class="modal-content">
            <div class="modal-header">
              <h2>Filters</h2>
              <button type="button" class="close clearButton" v-on:click="clearFilter" data-dismiss="modal">Clear
                All</button>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="main_select_wrp">
                <div class="flex selectwca_wrp">
                  <!-- <div class="multiselected" v-if="checkRole == 'Super Admin'"> -->
                    <!-- <label>Select City</label>
                    <multiselect track-by="value" v-model="clearFilters.city.value" label="name" placeholder="Select City"
                      :options="areas" name="areas" selectLabel="" deselectLabel="" selectedLabel="" @select="onChecked"
                      @remove="onRemove">
                    </multiselect> -->
                  <!-- </div> -->
                  <div class="multiselected">
                    <label>Status</label>
                      <multiselect track-by="value" v-model="clearFilters.status.value" label="name" placeholder="Select Status" :options="status" :key="status.length" name="status" selectLabel="" deselectLabel="" selectedLabel="" @select="onSelectStatus" @remove="onRemoveStatus"></multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="box-body">
        <!-- v-permission.if="['addCity']" -->
        <div :class="addButtonClass" class="word_details_wrp">
          <div class="filter_wrpp">
            <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#"
                xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                <g transform="translate(0 -1028.4)">
                  <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                  <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                  <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                  <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                </g>
              </svg>Apply Filter
              <span :class="{'counter_filter' : count }">{{ count }}</span>
            </button>
          </div>
          <router-link :to="{ name: 'wasteCollectionAreaCreate', params: { _id: '0' } }">
            <button class=" btn gradientbt">Add Zone</button>
          </router-link>
        </div>

        <!-- <v-server-table ref="wasteCollectionAreaCreateTable" url :limit="5" :columns="columns" :options="options" v-on:row-click="rowClick" @loaded="onLoaded"> -->
        <v-server-table class="table_wrp" ref="wasteCollectionAreaCreateTable" url :limit="5" :columns="columns"
          :options="options" @loaded="onLoaded">
          <template slot="beforeBody" >
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="action" slot-scope="props">
            <div class="d-flex justify-content-between collection_division_wrp collection_division_width">
              <a v-on:click.stop="action(props.row)" style="cursor:pointer;">
                Collection Division
              </a>
              <div class="py-2 text-center row">
                <label class="toggle">
                  <input class="toggle-checkbox" type="checkbox" :checked="props.row.status"
                    @click.prevent="(e) => activateWasteModal(props.row)" />
                  <span class="slider"></span>
                  <!-- <span
                    class="labels"
                    data-on="Active"
                    data-off="Deactivate"
                  ></span> -->
                </label>
              </div>
            </div>
          </template>
          <!-- <template>
                    <div class="form-group col-md-2">
                      <select
                        @change="applyFilter(custom_filter_select)"
                        class="form-control"
                      >
                        <option v-for="value in custom_filter_options" :key="value">{{value}}</option>
                      </select>
                    </div>
                    <button class="btn btn-default inline" @click="clearFilter('')">clear</button>
                  </template> -->
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { eventBus, wasteCollectionAreaService } from "../../../services";
import { USER_ROLES } from "../../../config";
import { ServerTable, Event } from "vue-tables-2";
import { mapState } from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import { Multiselect } from "vue-multiselect";

export default {
  name: "wasteCollectionArea",
  components: {
    Multiselect,
  },
  data() {
    return {
      loading: null,
      USER_ROLES: USER_ROLES,
      wasteCollectionAreaCreateTable: null,
      collectionData: {},
      areas: [],
      checkRole: "",
      count: null,
      count1: null,
      cityFilterCount: 0,
      activeInactiveStatus: 0,
      params: {},
      clearFilters: {
        city: "",
        status: "",
      },
      id: "",
      status: [{
              name: "Active",
              value: true
          },
          {
              name: "Inactive",
              value: false
          },
      ],
      columns: ["areaName", "subDivision", "totalHouse","routeFileUri", "action"],
      // custom_filter_options: ['Active', 'Inactive','status'],
      // custom_filter_select: '',
      options: {
        highlightMatches: true,
        headings: {
          cityName: "City",
          areaName: "Zone",
          subDivision: "Wards / Division",
          totalHouse: "Houses",
          routeFileUri: "Route Uploaded?",
          action: "Action",
        },
        perPage: 10,
        sortable: ["cityName","areaName"],
        requestFunction: (request) => {

          this.params.page = request.page;
          this.params.limit = request.limit;
          this.params.sortBy = "createdAt";
          this.params.sortOrder = "des";

          if (request.orderBy) {
            if (request.orderBy == "cityName") {
              this.params.sortBy = "cityData.cityName";
            } else {
              this.params.sortBy = request.orderBy;
            }
            if (request.ascending == 1) {
              this.params.sortOrder = "asc";
            } else {
              this.params.sortOrder = "des";
            }
          }

          if (request.query != "") {
            this.params.searchString = request.query.trim();
          } else {
            delete this.params.searchString;
          }
          if(this.count === 0 && this.count1 === 0) {
              this.count = null;
              this.count1 = null;
          }
          this.loading = true;
          return this.$wastecollectionareaDataRepository
            .collectionAreaList(this.params)
            .catch((error) => {
              console.error("Users.requestFunction-error:", error);
            });
        },

        responseAdapter: (response) => {
          this.loading = false;
          let wasteCollectionAreaResponse = [];
          let count;
          response.data.response.forEach((element) => {
            var wasteCollectionArea = element;
            wasteCollectionArea["cityName"] =
              element.data.cityData != null
                ? element.data.cityData.cityName
                : null;
            wasteCollectionArea["routeFileUri"] = element.routeFileUri != null ? "Yes" : "No";
            wasteCollectionAreaResponse.push(wasteCollectionArea);
          });
          if (wasteCollectionAreaResponse.length === 0) {
            count = 0;
          }

          return {
            data: wasteCollectionAreaResponse,
            count: response.data.total || count,
          };
        },

        customFilters: [
          {
            name: "custom_filter",
            callback: function (row, query) {
              //	return row.role[0] == query;
            },
          },
        ],
        uniqueKey: "_id",
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.wasteCollectionAreaCreateTable) {
        return this.wasteCollectionAreaCreateTable.count >
          this.wasteCollectionAreaCreateTable.limit ||
          this.wasteCollectionAreaCreateTable.limit > 10
          ? "shift-add-left"
          : "add-item";
      } else {
        return "add-item";
      }
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    // getCurrentLoggedinUserRank() {
    //     return store.state.auth.user.role.rank;
    // },


    onChecked(option) {
      // if (this.cityFilterCount === 0) {
      //   this.count1 === 0 || this.count1 === null ? this.count = 1 : this.count += this.count1;
      //   this.cityFilterCount = 1;
      // }
      this.clearFilters.city = option;
      let id = option.value;
      this.params.cityId = id;
      this.$refs.wasteCollectionAreaCreateTable.refresh();
    },
    onRemove() {
      this.count = this.count1;
      this.cityFilterCount = 0;
      this.params.cityId = "";
      this.$refs.wasteCollectionAreaCreateTable.refresh();
    },
    activateWasteModal(row) {
      let confirmtext;
      if (row.status === true) {
        confirmtext = "Deactive";
      } else {
        confirmtext = "Active";
      }
      swal({
        // title: "Are you sure?",
        title: `Are you sure you want to ${confirmtext}?`,
        // text: `Are you sure you want to ${confirmtext}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0f6940",
        cancelButtonColor: "#d33",
        confirmButtonText: `Yes, ${confirmtext}`,
      }).then((result) => {
        if (result.value) {
          this.activateWaste(row);
        } else {
          swal.close();
        }
      });
    },
    clearFilter() {
      this.clearFilters = {
        status: "",
      };
    
      this.count = null;
      this.cityFilterCount = 0;
      this.activeInactiveStatus = 0;

      this.params.status = "";
      this.$refs.wasteCollectionAreaCreateTable.refresh();
    },
    onSelectStatus(option){
        if(this.activeInactiveStatus === 0){
            this.activeInactiveStatus = 1;
            this.count += 1;
            this.count1 += 1;
        }
        if(this.$route.params.status === 'Active') {
            const option = {
                name: 'Acive',
                value: [{
                    name: 'Active',
                    value: true
                }]
            };
            this.clearFilters.status = option;                
            this.params.status = true;
        } else{
        this.clearFilters.status = option;
        this.params.status = option.value;
        this.$refs.wasteCollectionAreaCreateTable.refresh();
        }
    },
    onRemoveStatus(){
        this.activeInactiveStatus = 0;
        this.count -= 1;
        this.count1 -= 1;
        this.clearFilters.status = "";
        this.params.status = "";
        this.$refs.wasteCollectionAreaCreateTable.refresh();
    },
    activateWaste(row) {

      this.id = row._id;
      let confirmtext;
      if (row.status === true) {
        confirmtext = "Deactive";
      } else {
        confirmtext = "Active";
      }
      this.loading = true;
      let data = [
        {
          areaName: row.areaName,
          cityId: row.data.cityData._id,
          areaLocation: row.areaLocation,
          dumpyardId: row.dumpyardId,
          segregationId: row.segregationId,
          transportId: row.transportId,
          _id: row._id,
        },
      ];


      this.collectionData = {};
      this.collectionData["areaName"] = row.areaName;
      this.collectionData["cityId"] = row.data.cityData._id;
      this.collectionData["areaLocation"] = row.data.areaLocation;
      this.collectionData["userId"] = store.state.auth.user._id;
      this.collectionData["dumpyardId"] = row.data.dumpyardId;
      this.collectionData["segregationId"] = row.data.segregationId;
      this.collectionData["transportId"] = row.data.transportId;
      this.collectionData["status"] = !row.status;
      this.collectionData["_id"] = this.id;

      return wasteCollectionAreaService
        .updateWasteCollectionArea(this.collectionData)
        .then((response) => {
          this.loading = false;
          row.status = !row.status;
          this.$snotify.success(
            `The ${row.areaName} has been marked ${confirmtext}.`
          );
        })
        .catch((error) => {
          this.loading = false;
          console.error("TransportPoint.activateTransportPoint-error:", error);
          this.$snotify.error("Activate user failed", "Error!");
        });
    },

    rowClick(data) {
      // if (store.state.auth.user.role.rank <= data.row.role.rank) {
      this.$router.push({
        name: "wasteCollectionAreaCreate",
        params: {
          _id: data.row._id,
        },
        props: data.row,
      });
      // } else {
      //     this.$snotify.error('You can`t update this user', 'Access Denied!');
      // }
    },
    onLoaded() {
      this.wasteCollectionAreaCreateTable = this.$refs.wasteCollectionAreaCreateTable;
    },
    // clearFilter() {
    //   this.custom_filter_select = "";
    // },
    applyFilter(filter_val) {
      Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
    },
    getCityList() {
      this.loading = true;
      let data = [];
      const params = {};
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            let val = {};
            val["name"] = element.cityName.length > 20 ? element.cityName.slice(0, 20) + "..." : element.cityName;
            val["value"] = element._id;
            data.push(val);
          });
          this.areas = data.sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch((error) => {
          this.loading = false;
          console.error("cities.requestFunction-error:", error);
          this.$snotify.error("Get cities list failed", "Error!");
        });
    },
    action(row) {
      // let iddd
      // iddd = row._id
      // eventBus.$emit("wcaId",iddd)

      // this.$store.dispatch("setwcaId", row._id);
      this.$router.push({
        name: "wasteCollectionAreaDetails",
        params: {
          _id: row._id,
        },
        props: row,
      });
    },
  },
  mounted() {
    this.params.cityId = this.$store.state.auth.cityId.value
    eventBus.$on('cityIdChanged', this.onChecked);
    if (this.$store.state.auth.user.role.key === "superAdmin") {
      this.columns.unshift("cityName");
    }
    this.getCityList();
    eventBus.$on("DATA_PUBLISHED", (payload) => { });
    this.checkRole = this.$store.state.auth.user.role.name;
  },
  beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onChecked);
    },
  created() {
    this.clearFilters = {
      ...this.clearFilters,
      city: {
        ...this.clearFilters.city,
        value: this.$route.params.cityIds
      }
    }
    
    if (this.$route.params.cityIds && this.$route.params.cityIds.value) {
      this.params.cityId = this.clearFilters.city.value.value;
      // if (this.cityFilterCount === 0) {
      //   this.count = 1;
      //   this.cityFilterCount = 1;
      // }
      if (this.$refs.wasteCollectionAreaCreateTable && this.$refs.wasteCollectionAreaCreateTable.refresh()){
        this.$refs.wasteCollectionAreaCreateTable.refresh();
      }
      
    }
    if( this.$route.params.status === "Active") {
      this.onSelectStatus();
    }
  }
};
</script>

<style>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
  background: #0f6940;
  color: white;
}

.collection_division_wrp a {
  color: #0f6940;
  margin-right: 30px;
}

.collection_division_wrp {
  display: flex;
  align-items: center;
}

.table_wrp table tr td:first-child {
  width: 105px;
}

.table_wrp table tr td {
  max-width: 100px;
}

.waste_collection_wrp .table>thead:first-child>tr th:nth-child(1) {
  max-width: 300px;
  width: 300px;
}

.waste_collection_wrp .table>thead:first-child>tr th:nth-child(3) {
  width: 150px;
}

.waste_collection_wrp .table>thead:first-child>tr th:nth-child(4) {
  width: 150px;
}

@media (max-width: 1499px) {
  .waste_collection_wrp .table>thead:first-child>tr th:nth-child(1) {
    width: 190px;
  }

  .waste_collection_wrp .table>thead:first-child>tr th:nth-child(3) {
    width: 135px;
  }

  .waste_collection_wrp .table>thead:first-child>tr th:nth-child(4) {
    width: 135px;
  }
}

@media (max-width: 1299px) {
  .waste_collection_wrp .table>thead:first-child>tr th:nth-child(1) {
    width: auto;
  }
}

@media only screen and (min-width: 1299px) {
  .table_wrp table tr td {
    max-width: 142px;
  }
}

@media only screen and (min-width: 1399px) {
  .table_wrp table tr td {
    max-width: 120px;
  }
}

.collection_divisions_table table tr:nth-child(1) th {
  background: #ddd;

}

.filter_wrpp button svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.filter_wrpp button:hover {
  background: #0f6940;
  color: #fff;
}

.gradientbt {
  background: #0f6940;
  color: white;
}

.main_select_wrp_relative .modal-dialog {
  width: 57% !important;
}

.main_select_wrp_relative+.add-item {
  display: flex;
}

.filter_wrpp button {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

@media(max-width:767px) {
  .main_select_wrp_relative .modal-dialog {
    width: 94% !important;
  }
}

.main_select_wrp_relative {
  position: absolute;
  right: 30%;
  top: 25px;
}

@media(max-width:767px) {
  .word_details_wrp .btn.gradientbt {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// wasteCollectionArea.vue?422101dc